import I18n from '@src/i18n';
import React from 'react';
import { Bar, HorizontalBar, Line } from 'react-chartjs-2';

import { Button, Col, Input, Row, Select } from '../../node_modules/antd';
import styled from '../../node_modules/styled-components';

type PropType = {
    fields?: string[]
    title?: string;
    loading: boolean;
    description?: string[];
    options?: any;
    selectionText?: string;
    chartData: any;
    chartType: string;
    useExtraFields?: boolean;
    loadingUserFields?: boolean;

    onHandleExtraFieldChange?: Function;
    onSearchExtraFieldData?: Function;


}

type StateType = {
    fieldSelectedLabel: any;
    inputExtraFieldValue?: string;
    searchedForData?: boolean;
};

const Option = Select.Option;

const defaultOptions = {
    maintainAspectRaio: true
}

class DashboardDynamicChart extends React.Component<PropType, StateType> {

    state: StateType = {
        fieldSelectedLabel: undefined,
    }

    constructor(props: any) {
        super(props);

        this.handleFieldSelectChange = this.handleFieldSelectChange.bind(this);
        this.onInputExtraFieldChanged = this.onInputExtraFieldChanged.bind(this);
        this.getCurrentExtraFieldValue = this.getCurrentExtraFieldValue.bind(this);
        this.onSearchExtraFielDataClicked = this.onSearchExtraFielDataClicked.bind(this);
    }

    handleFieldSelectChange(value: any) {
        const { onHandleExtraFieldChange } = this.props;
        if (onHandleExtraFieldChange)
            onHandleExtraFieldChange(value);

        this.setState({ fieldSelectedLabel: value, });
    }

    onInputExtraFieldChanged(e: any) {
        let value = e.target.value;

        this.setState({ inputExtraFieldValue: value });
    }

    renderExtraFieldsSelection = () => {
        return (
            <Select defaultValue="-" style={{ width: "70%" }} onChange={this.handleFieldSelectChange}>
                <Option key={0} value={'-'}>{'-'}</Option>
                {(this.props.fields) &&
                    this.props.fields.map((item: string, i: number) => {
                        return <Option key={i + 1} value={item}>{item}</Option>
                    })
                }
            </Select>
        );
    }
    getCurrentExtraFieldValue() {
        return this.state.inputExtraFieldValue;
    }

    onSearchExtraFielDataClicked() {
        if (this.props.onSearchExtraFieldData) {
            this.props.onSearchExtraFieldData(this.state.inputExtraFieldValue);
        }
        this.setState({ searchedForData: true });
    }

    renderExtraFieldInput() {
        return (
            <div>
                <Col md={17} style={{ marginRight: "10px" }}>
                    <Input
                        onChange={this.onInputExtraFieldChanged}
                        placeholder={I18n.l('dashboard.placeholders.insertFieldInput').replace("{fieldLabel}", this.state.fieldSelectedLabel)}
                    />
                </Col>
                <Col span={1} md={6}>

                    <Button
                        type="primary" size="large"
                        className="search-field-data-btn"
                        onClick={() => {
                            this.props.onSearchExtraFieldData && (
                                this.onSearchExtraFielDataClicked()
                            )
                        }
                        }
                    >
                        {I18n.l('common.search')}
                    </Button>

                </Col>
            </div>

        )
    }

    renderChart = () => {
        switch (this.props.chartType) {
            case "line":
                return (<Line data={this.props.chartData} options={(!!this.props.options ? this.props.options : defaultOptions)} />);
            case "bar":
                return (<Bar data={this.props.chartData} options={(!!this.props.options ? this.props.options : defaultOptions)} />);
            case "horizontalBar":
                return (<HorizontalBar data={this.props.chartData} options={(!!this.props.options ? this.props.options : defaultOptions)} />);
            default:
                return (<Line data={this.props.chartData} options={(!!this.props.options ? this.props.options : defaultOptions)} />);
        }
    }

    renderDescription() {
        const { description } = this.props;
        return (
            <Col sm={24} md={12} lg={14} >
                {description &&
                    description.map((line: string, i: number) => {
                        return <Row key={i} className={"description"}>{line}</Row>
                    })}
            </Col>
        );
    }

    rand(min: number, max: number, num: number) {
        var rtn = [];
        while (rtn.length < num) {
            var value = ((Math.random() * (max - min)) + min).toFixed(2);
            rtn.push(value);
        }
        return rtn;
    }

    render() {
        const {
            fields,
            selectionText,
            chartData,
            description,
            loading,
            useExtraFields,
            loadingUserFields,
        } = this.props;
        const {
            fieldSelectedLabel,
            searchedForData
        } = this.state;

        if (useExtraFields) {

            return (

                <Wrapper>
                    <Row>
                        <Row>
                            <h2 style={{ fontWeight: 'bold', marginTop: '70px' }}>{(!!this.props.title ? this.props.title : "")}</h2>
                        </Row>

                        {description != undefined && description.length > 0 && (
                            <Row className={"goepik-component-padding"}>
                                {this.renderDescription()}
                            </Row>
                        )}
                    </Row>
                    {loadingUserFields && (
                        <Row className="goepik-component-padding">{I18n.l('common.loadingData')}</Row>
                    )}
                    {loadingUserFields == false && (fields == undefined || fields.length == 0) && (
                        <Row>
                            <Row className={"goepik-big-top-margin"}>
                                <Col sm={12} md={12}>
                                    <Col sm={24} md={12}>
                                        <h3 className={"title3"}>{selectionText}</h3>
                                    </Col>
                                    <Col sm={24} md={12}>
                                        <Select defaultValue="-" style={{ width: "70%" }} onChange={this.handleFieldSelectChange}>
                                            <Option value={"-"}>{"-"}</Option>
                                        </Select>
                                    </Col>
                                </Col>
                            </Row>
                            <Row className={"goepik-medium-top-margin"}>
                                <Row className="goepik-text-lightGray-bold">{I18n.l('dashboard.texts.noExtraField')}</Row>
                                <Row className="goepik-text-lightGray-bold">{I18n.l('dashboard.texts.whereCreateFields')}</Row>
                            </Row>
                        </Row>
                    )}

                    {loadingUserFields == false && (!!fields && fields.length > 0) && (
                        <Row type="flex" justify="start" className={"goepik-big-top-margin"} align="middle">
                            <Col sm={18} md={20} lg={20}>
                                <Col sm={24} md={7}>
                                    <h3 className={"title3"}>{selectionText}</h3>
                                </Col>
                                <Col sm={24} md={7}>
                                    {this.renderExtraFieldsSelection()}
                                </Col>
                                {fieldSelectedLabel && fieldSelectedLabel !== "-" && (
                                    <Col sm={24} md={10}>
                                        {this.renderExtraFieldInput()}
                                    </Col>
                                )}
                            </Col>
                        </Row>
                    )}
                    {loadingUserFields == false && loading == true && (
                        <Row className={"goepik-medium-top-margin"}>
                            <p>{I18n.l('common.loadingData')}</p>
                        </Row>
                    )}
                    {loadingUserFields == false && loading == false && searchedForData && (chartData == undefined || chartData.length == 0) && (
                        <Row className={"goepik-big-top-margin"}>
                            <Col sm={12} md={16} lg={24}>
                                <p className="goepik-text-lightGray-bold">{I18n.l('dashboard.noData')}</p>
                            </Col>
                        </Row>
                    )}
                    {(loading == false && loadingUserFields == false) && (chartData) && (
                        <Row type="flex">
                            <Col className={"chart"}>
                                {this.renderChart()}
                            </Col>
                        </Row>
                    )}
                </Wrapper>

            );
        }
        else {
            return (

                <Wrapper>
                    <Row>
                        <Row>
                            <h2 style={{ fontWeight: 'bold', marginTop: '70px' }}>{(!!this.props.title ? this.props.title : "")}</h2>
                        </Row>

                        {description != undefined && description.length > 0 && (
                            <Row className={"goepik-component-padding"}>
                                {this.renderDescription()}
                            </Row>
                        )}
                    </Row>
                    {loading == true && (
                        <Row className={"goepik-medium-top-margin"}>
                            <p>{I18n.l('common.loadingData')}</p>
                        </Row>
                    )}

                    {loading == false && (chartData == undefined || chartData.length == 0) && (
                        <Row className={"goepik-big-top-margin"}>
                            <Col sm={12} md={16} lg={24}>
                                <p className="goepik-text-lightGray-bold">{I18n.l('dashboard.noData')}</p>
                            </Col>
                        </Row>
                    )}
                    {loading == false && (chartData) && (
                        <Row type="flex">
                            <Col className={"chart"}>
                                {this.renderChart()}
                            </Col>
                        </Row>
                    )}
                </Wrapper>

            );
        }

    }
}

const Wrapper = styled.div`
    .title2{
        font-weight: bold;
    }
    .title3{
        font-weight: bold;
    }

    .description:not(:first-child){
        margin-top: 9px;
    }

    .chart{
        width: 750px;
    }
    
    .search-field-data-btn{
        height: 32px;
        font-size: 14px;
        font-weight: bold;
    }
`;

export default DashboardDynamicChart;